import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscriber } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RepintelApiService } from './api';
import { RepIntelSignalItemDto, RepIntelSignalsResponseDto } from '../dto';

@Injectable({
  providedIn: 'root'
})
export class RepIntelSignalsService {
  private cancelInitSubject: Subject<symbol> = new Subject<symbol>();
  private readonly signalsSubject: BehaviorSubject<RepIntelSignalItemDto[]> = new BehaviorSubject(null);

  constructor(private readonly repintelApiService: RepintelApiService) {
  }

  getSignals(): Observable<RepIntelSignalItemDto[]> {
    return this.signalsSubject.asObservable();
  }

  init(): Observable<boolean> {
    this.cancelInitSubject.next(Symbol(''));

    return new Observable((subscriber: Subscriber<boolean>) => {
      if (this.signalsSubject.getValue()) {
        subscriber.next(true);
        subscriber.complete();
        return;
      }
      this.repintelApiService.getSignals().pipe(takeUntil(this.cancelInitSubject)).subscribe((res: RepIntelSignalsResponseDto) => {
        this.signalsSubject.next((res?.signals || []));
        subscriber.next(true);
        subscriber.complete();
      }, () => {
        subscriber.next(true);
        subscriber.complete();
      });
    })

  }
}
